import React from 'react';
import { Paper, Box, Avatar, Typography, Chip, IconButton, CircularProgress } from '@mui/material';
import Iconify from '../../components/iconify/Iconify';

// ----------------------------------------------------------------------

export default function ProfileImageSection({
  userId,
  userData,
  profileImagePreview,
  profileImage,
  isEditing,
  canEdit,
  isSubmitting,
  onImageUpload,
  onRemoveImage
}) {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 3,
        textAlign: 'center',
        borderRadius: 2,
        boxShadow: 2,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-block' }}>
        <Avatar
          src={profileImagePreview || profileImage}
          sx={{
            width: 120,
            height: 120,
            mx: 'auto',
            mb: 2,
            fontSize: '3rem',
          }}
        >
          {userData?.userName?.charAt(0)?.toUpperCase()}
        </Avatar>
        
        {isEditing && canEdit && (
          <Box sx={{ position: 'absolute', bottom: 8, right: 8 }}>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id={`profile-image-upload-${userId || 'current'}`}
              type="file"
              onChange={onImageUpload}
            />
            <IconButton
              component="label"
              htmlFor={`profile-image-upload-${userId || 'current'}`}
              size="small"
              disabled={isSubmitting}
              sx={{
                backgroundColor: 'primary.main',
                color: 'white',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
                '&:disabled': {
                  backgroundColor: 'grey.400',
                  color: 'grey.600',
                },
                width: 32,
                height: 32,
              }}
              aria-label="Upload profile image"
            >
              {isSubmitting ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <Iconify icon="eva:camera-fill" width={16} />
              )}
            </IconButton>
          </Box>
        )}

        {isEditing && canEdit && (profileImagePreview || profileImage) && (
          <Box sx={{ position: 'absolute', bottom: 8, left: 8 }}>
            <IconButton
              size="small"
              onClick={onRemoveImage}
              sx={{
                backgroundColor: 'error.main',
                color: 'white',
                '&:hover': {
                  backgroundColor: 'error.dark',
                },
                width: 32,
                height: 32,
              }}
              aria-label="Remove profile image"
            >
              <Iconify icon="eva:close-fill" width={16} />
            </IconButton>
          </Box>
        )}
      </Box>
      {isEditing && canEdit && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            mt: 0.1, // slightly less space
            display: 'block',
            fontSize: '0.7rem', // smaller caption text
            textAlign: 'center',
          }}
        >
          Click camera icon to upload image
        </Typography>
      )}

      <Typography variant="h6" gutterBottom>
        {userData?.userName}
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          wordBreak: 'break-all',
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {userData?.email}
      </Typography>

      <Box sx={{ mt: 0.5 }}>
        <Chip
          size="small"
          label={userData?.status === 'active' ? 'Active' : 'Inactive'}
          color={userData?.status === 'active' ? 'success' : 'default'}
          variant={userData?.status === 'active' ? 'filled' : 'outlined'}
        />
      </Box>
    </Paper>
  );
}
